import { PromotionalCardBase } from "../card-base";
import { PromotionalCardProps, SOCIAL_URLS } from "../types";

// Instagram gradient logo icon
function InstagramIcon({ className }: { className?: string }) {
	return (
		<svg className={className} viewBox="0 0 24 24" fill="none">
			<defs>
				<linearGradient id="instagram-gradient" x1="0%" y1="100%" x2="100%" y2="0%">
					<stop offset="0%" stopColor="#FFDC80" />
					<stop offset="25%" stopColor="#F77737" />
					<stop offset="50%" stopColor="#F56040" />
					<stop offset="75%" stopColor="#C13584" />
					<stop offset="100%" stopColor="#833AB4" />
				</linearGradient>
			</defs>
			<path
				fill="url(#instagram-gradient)"
				d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"
			/>
		</svg>
	);
}

export function InstagramCard({ className }: PromotionalCardProps) {
	return (
		<PromotionalCardBase
			icon={<InstagramIcon className="w-full h-full" />}
			title="Follow Us on Instagram"
			description="Explore stunning properties & home inspiration daily"
			ctaText="Follow @settlin_in"
			href={SOCIAL_URLS.INSTAGRAM}
			className={className}
		/>
	);
}
